import { styled, theme } from "../../../../../../styles/stitches.config"
import * as RadioGroup from "@radix-ui/react-radio-group"
import { Button } from "../../../../../../components/button/Button"

export const RadioGroupRoot = styled(RadioGroup.Root, {
  display: "flex",
  flexDirection: "column",

  "@lg": {
    flexDirection: "row",

    "& > :last-child": {
      flex: 2,
    },
  },
})

export const RadioGroupItem = styled(RadioGroup.Item, {
  backgroundColor: theme.colors.white,
  width: 19,
  height: 19,
  borderRadius: "100%",
  marginLeft: "auto",
  transition: ".3s ease-in-out",
  padding: 0,
  marginBottom: theme.space.s0_5,
  flexShrink: 0,

  "&[data-state='checked']": {
    border: `2px solid ${theme.colors.secondary}`,
  },
  "&[data-state='unchecked']": {
    border: `2px solid ${theme.colors.textsAlt}`,
  },

  variants: {
    selected: {
      true: {
        border: `2px solid ${theme.colors.secondary}`,
      },
      false: {
        border: `2px solid ${theme.colors.textsAlt}`,
      },
    },
  },
})

export const RadioGroupIndicator = styled(RadioGroup.Indicator, {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  position: "relative",

  "&::after": {
    content: '""',
    display: "block",
    width: 9,
    height: 9,
    borderRadius: "50%",
    backgroundColor: theme.colors.secondary,
  },
})

export const Label = styled("label", {
  display: "flex",
  gap: theme.space.s2,
  alignItems: "center",
  textTransform: "uppercase",
  fontSize: theme.fontSizes.small,
  color: theme.colors.secondary,
  fontWeight: theme.fontWeights.bold,
  boxShadow: theme.shadows.light,
  height: theme.sizes.s21,
  cursor: "pointer",
  paddingLeft: theme.sizes.s4,
  paddingRight: theme.sizes.s4,
  transition: "all .3s ease-in-out",

  variants: {
    selected: {
      true: {
        border: `2px solid ${theme.colors.secondary}`,
      },
      false: {
        border: `2px solid ${theme.colors.white}`,
      },
    },
  },

  "@sm": {
    fontSize: theme.fontSizes.regular,
  },
})

export const ContactButtonStyled = styled(Button, {
  maxWidth: "215px",
  height: "51px",
  fontSize: `${theme.fontSizes.regular}!important`,
  backgroundColor: "#FFA913FF!important",
  textTransform: "uppercase",
  border: "none!important",
  boxShadow: `${theme.shadows.mediumLight}!important`,
  color: `${theme.colors.white}!important`,

  "@sm": {
    marginLeft: "43px",
  },
})
